// Shared preset → Tailwind class maps for user-configurable text sizes.
// Presets combine mobile → md → lg breakpoints and are picked by keys like
// 'sm' | 'md' | 'lg' | 'xl' from the Admin Panel dropdowns.

export const HEADING_PRESETS = {
  xs: 'text-sm md:text-base',
  sm: 'text-base md:text-lg lg:text-xl',
  md: 'text-lg md:text-xl lg:text-2xl',
  lg: 'text-xl md:text-2xl lg:text-3xl', // default
  xl: 'text-2xl md:text-3xl lg:text-4xl',
};

export const SUBHEADING_PRESETS = {
  xs: 'text-base md:text-lg',
  sm: 'text-lg md:text-xl lg:text-2xl',
  md: 'text-xl md:text-2xl lg:text-3xl',
  lg: 'text-2xl md:text-3xl lg:text-4xl',
  xl: 'text-3xl md:text-4xl lg:text-5xl', // default
  '2xl': 'text-4xl md:text-5xl lg:text-6xl',
};

// Compact subheading preset for narrow contexts (e.g. hero banner blurb).
export const SUBHEADING_COMPACT_PRESETS = {
  xs: 'text-xs md:text-sm',
  sm: 'text-sm md:text-base',
  md: 'text-base md:text-lg',
  lg: 'text-base md:text-lg lg:text-xl', // default
  xl: 'text-lg md:text-xl lg:text-2xl',
  '2xl': 'text-xl md:text-2xl lg:text-3xl',
};

export const resolveSizeClass = (value, presets, fallbackKey) => {
  if (!value) return presets[fallbackKey];
  // Allow raw Tailwind class overrides ("text-3xl md:text-4xl lg:text-5xl").
  if (typeof value === 'string' && value.includes('text-')) return value;
  return presets[value] || presets[fallbackKey];
};
